export enum ActionExecutionLocation {
    AlwaysOnTarget = "AlwaysOnTarget",
    AlwaysOnServer = "AlwaysOnServer",
    TargetOrServer = "TargetOrServer",
}

export default ActionExecutionLocation;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/actionExecutionLocation.ts